module.exports = __webpack_public_path__ + "img/profile.ed9dc16c.jpg";